import { useEffect } from "react";
import { Slider } from "frno-react";
import DynamicText from "../../common/DynamicText";
import useApplicationStore from "../../../state/ApplicationStore";
import useTextStore from "../../../state/TextStore";

type RiskFilterProps = {
  idPrefix?: "desktop-" | "mobile-";
};
export default function RiskFilter({ idPrefix }: RiskFilterProps) {
  const defaultRiskValues = {
    min: 1,
    max: 7,
  };

  const { selectedRisk, setSelectedRisk } = useApplicationStore();
  const { getTextByKey } = useTextStore();

  useEffect(() => {
    setSelectedRisk(defaultRiskValues);
  }, []);

  const handleRiskChange = (minValue: number, maxValue: number) => {
    setSelectedRisk({
      min: minValue,
      max: maxValue,
    });
  };

  return (
    <div className="filter price mt-8">
      <div className="fs-h4 fw-500 mt-6 mb-4">
        <DynamicText textKey="filter.risk.header" />
      </div>
      <Slider
        idPrefix={idPrefix}
        minValue={defaultRiskValues.min}
        maxValue={defaultRiskValues.max}
        currentMin={selectedRisk.min}
        currentMax={selectedRisk.max}
        step={1}
        onChange={handleRiskChange}
        minValueLabel={getTextByKey("filter.risk.minvalue.label")}
        maxValueLabel={getTextByKey("filter.risk.maxvalue.label")}
      />
    </div>
  );
}
